import AddressFields from 'components/Address';

const SatNoteAddressFields: React.FunctionComponent = function () {
  return (
    <div className="flex flex-col">
      <div className="mt-2 mb-6 border-b border-neutral-300 w-full" />
      <div className="font-bold text-14-22-em text-neutral-700 mb-6">
        Please confirm the address the work has been completed at or the goods
        have been delivered to
      </div>
      <AddressFields baseFieldName="job.sat_note.address" />
      <div className="mt-2 mb-6 border-b border-neutral-300 w-full" />
    </div>
  );
};

export default SatNoteAddressFields;
